import type { ScreenSchema } from './types';

const toggleSchema: ScreenSchema = {
  template: 'toggle',
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' }
      ]
    },
    // Played after all toggles are completed
    feedback: { parts: [{ field: 'feedback' }] }
  }
};

export default toggleSchema;
